'use client';
import { useState } from 'react';

import clsx from 'clsx';
import { useAtomValue, useAtom } from 'jotai';
import { Dialog, VisuallyHidden } from 'radix-ui';

import { Modal } from '@quick/components/Modal';
import type { LoginRes } from '@quick/go-api-types/users/v2/login';

import { useAppTranslation } from '@/app/i18n/client';
import { LoginComponent } from '@/components/core/Login';

import { loginAtom } from './atoms';

export default function Login() {
  const loginModal = useAtomValue(loginAtom);

  if (!loginModal) return null;
  return <LoginModal />;
}

export function LoginModal() {
  const { t } = useAppTranslation(['dl']);
  const twoFactor = useState<Omit<LoginRes, 'two_factor'> | null>(null);
  const [twoFactorToken] = twoFactor;
  const [loginModal, setLoginModal] = useAtom(loginAtom);

  return (
    <Modal
      className="absolute left-0 top-0 z-50 dark:bg-gray-500/25"
      isOpen={loginModal}
      onClose={() => setLoginModal(false)}
      contentClassName={clsx(
        !twoFactorToken && '!bg-transparent !border-0 !p-0 overflow-y-auto'
      )}
      hideClose
    >
      <VisuallyHidden.Root>
        <Dialog.Title>{t('dl:login.title')}</Dialog.Title>
      </VisuallyHidden.Root>
      <div className="h-full max-w-full">
        <LoginComponent
          twoFactor={twoFactor}
          className="self-center"
          onSuccess={() => setTimeout(() => setLoginModal(false), 0)}
        />
      </div>
    </Modal>
  );
}
